// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"bc87db37","204":"f8cd8183"}[chunkId] + ".chunk.js";
};